export enum PermissionsChangedEnum {
  Uninitialized,
  Set,
  Cleared,
}
